export default __webpack_public_path__ + "static/media/ensvee-logo-white.75c65a8e.svg";